import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  open: boolean;
  titel: string;
  onSluit: () => void;
  onVerzend: () => void | Promise<void>;
  bezig?: boolean | undefined;
  fout?: string | null | undefined;
  verzendLabel?: string | undefined;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | undefined;
  children: ReactNode;
}

/**
 * Een dialoog met een formulier: de inhoud, een algemene foutmelding bovenaan en knoppen om op te slaan of te
 * annuleren. Klikken naast de dialoog sluit hem niet, zodat ingevulde gegevens niet per ongeluk verdwijnen.
 * @param props De titel, de inhoud, de foutmelding en wat er bij verzenden gebeurt.
 * @returns De dialoog.
 */
export function FormulierDialoog({
  open,
  titel,
  onSluit,
  onVerzend,
  bezig = false,
  fout,
  verzendLabel = 'Opslaan',
  maxWidth = 'sm',
  children,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={(_gebeurtenis, reden) => {
        if (reden !== 'backdropClick') {
          onSluit();
        }
      }}
      maxWidth={maxWidth}
      fullWidth
    >
      <form
        noValidate
        onSubmit={(gebeurtenis) => {
          gebeurtenis.preventDefault();
          void onVerzend();
        }}
      >
        <DialogTitle>{titel}</DialogTitle>
        <DialogContent dividers>
          {fout && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {fout}
            </Alert>
          )}
          {children}
        </DialogContent>
        <DialogActions>
          <Button onClick={onSluit} disabled={bezig}>
            Annuleren
          </Button>
          <Button type="submit" variant="contained" loading={bezig}>
            {verzendLabel}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
